//Get Campaigns details
import Campaigns from "@/services/Campaigns";
import Discounts from "@/services/Discounts";
import DiscountDetails from "@/services/DiscountDetails";
import Users from "@/services/Users";
export default {
	data() {
		return {
			userList: [],
			//manageSingleDiscount
			curDiscount: {},
			discountMethod: "",
			couponHistory: [],
			campaign: [],
			groupsOfDiscounts: [],
			groupOfDiscounts: {},
			discountsList: [],
			//Menu management
			campaingSubMenu: false,
			displayDiscountManagement: false,
			// Rights management
			pageRights: {
				modifyCampaign: false,
				retrieveCoupon: false,
				exportCampaign: false,
				manageCampaignUser: false,
				logCampaign: false,
				manageDiscount: false,
				displayCouponHistory: false,
			},
			confirmationData: {
				cancel: this.$t("button.cancel"),
				data: {},
				description: "",
				proceedButton: "",
				process: "",
				title: ""
			},
			show: {
				confirm: false
			}
		}
	},
	methods: {
		archiveDiscount(data) {
			Discounts.partialUpdate(data.id, {
				archived: !data.archived
			}).then(
				res => {
					if (res.status == 204) {
						data.archived = !data.archived;
					}
				});
		},
		checkUserRights() {
			this.pageRights.modifyCampaign =
				this.$store.getters.USERPROFILE["campaign-administration"] &&
				this.campaign["status"] != 3;
			this.pageRights.exportCampaign = this.$store.getters.USERPROFILE["coupon-export"];
			this.pageRights.displayCouponHistory = (this.$store.getters.USERPROFILE["campaign-administration"] || this.$store.getters.USERPROFILE["campaign-follow-up"]);
			this.pageRights.manageCampaignUser = this.$store.getters.USERPROFILE[
				"campaign-administration"
			];
			this.pageRights.retrieveCoupon = this.$store.getters.USERPROFILE[
				"coupon-retrieval"
			];
			this.pageRights.logCampaign = false; //this.$store.getters.USERPROFILE["campaign-administration"];
			this.pageRights.manageDiscount =
				this.$store.getters.USERPROFILE["campaign-administration"] &&
				this.campaign["status"] != 3;
		},
		getUserList(campaignId) {
			Users.getUsersByCampaign(campaignId).then(
				res => {
					if (res.status == 200) {
						res.data = res.data.sort(function (a, b) {
							if (
								(a["first-name"] + " " + a["name"]).toLowerCase() <
								(b["first-name"] + " " + b["name"]).toLowerCase()) {
								return -1;
							}
							if (
								(a["first-name"] + " " + a["name"]).toLowerCase() >
								(b["first-name"] + " " + b["name"]).toLowerCase()) {
								return 1;
							}
							return 0;
						})
						this.userList = res.data
					}

				});
		},
		archiveCampaign(data, state) {
			Campaigns.partialUpdate(data.id, {
				status: state
			}).then(res => {
				if (res.status == 204) {
					this.campaign.status = state;
					if (state == 3)
						this.checkUserRights()// if campaign is closed upate the rights
				} else {
					console.log("Error: Impossible to archive");
				}
			});
			this.campaingSubMenu = false;
		},
		manageMenu(e) {
			let target = e.target;
			var el1 = this.$refs.mainMenu1;
			var el2 = this.$refs.mainMenu2;
			if (target && el1 && el2) {
				if (el1 !== target && el2 !== target) {
					this.campaingSubMenu = false;
				}
			}
		},
		// Over the page display management
		updateDiscount() {
			this.displayDiscountManagement = false;
			this.getDiscountsByCampaignId(this.$route.params.id);
		},
		addDiscountToGroupOfDiscount(groupOfDiscounts) {
			this.groupOfDiscounts = groupOfDiscounts;
			this.discountMethod = "add_discount";
			this.displayDiscountManagement = true;
		},
		modifyDiscount(currentdiscount) {
			this.discountMethod = "modify_discount";
			this.curDiscount = currentdiscount;
			this.displayDiscountManagement = true;
		},
		prepareClose(data) {
			this.confirmationData.data = data;
			this.confirmationData.proceedButton = this.$t(
				"button.confirmCloseCampaign"
			);
			this.confirmationData.process = "closeCampaign";
			this.confirmationData.title =
				this.$t("campaigns.confirmCloseTitle") + ' "' + data["name"] + '"';
			this.confirmationData.description = this.$t(
				"campaigns.confirmCloseDescription"
			);
			this.show.confirm = true;
		},
		prepareArchive(data) {
			this.confirmationData.data = data;
			this.confirmationData.proceedButton = this.$t(
				"button.confirmArchiveCampaign"
			);
			this.confirmationData.process = "archiveCampaign";
			this.confirmationData.title =
				this.$t("campaigns.confirmArchiveTitle") + ' "' + data["name"] + '"';
			this.confirmationData.description = this.$t(
				"campaigns.confirmArchiveDescription"
			);
			this.show.confirm = true;
		},
		continueProcess(data) {
			switch (data.process) {
				case "archiveCampaign":
					this.archiveCampaign(data.data, 2);
					break;
				case "closeCampaign":
					this.archiveCampaign(data.data, 3);
					break;
				default:
					break;
			}
		},
		createDiscountWithParams(discount, groupOfDiscounts, discountDescriptions) {
			discount["group-of-discounts-id"] = groupOfDiscounts.id;
			//si en currency  valeur en cts
			if (discount["discount-type"] == 1)
				discount["discount-value"] = discount["discount-value"] * 10 * 10;
			//ajout du discount
			Discounts.add(discount["group-of-discounts-id"], discount).then(
				res => {
					if (res.status == 201) {
						this.updateDiscount()
						let location = res.headers.location.split("/");
						let id = location[location.length - 1];
						// création des différents Discount details
						//récupération de la liste de l'array de discoutDescriptions
						var languages = Object.keys(discountDescriptions);
						for (let i = 0; i < languages.length; i++) {
							if (discountDescriptions[languages[i]].description != "") {
								DiscountDetails.add(id, {
									language: discountDescriptions[languages[i]].code,
									description: discountDescriptions[languages[i]]
										.description,
									archived: false
								}).then();
							}
						}
					}
				}
			);
		},
		updateDiscountWithParams(discount, discountDescriptions) {
			//si en currency  valuer en cts
			console.log("updateDiscountWithParams")
			console.log(discount["discount-value"])
			if (discount["discount-type"] == 1) {
				var discountValue = discount["discount-value"] * 10 * 10
				discount["discount-value"] = discountValue;
			}
			console.log(discount["discount-value"])
			//	discount["discount-value"] = discount["discount-value"] * 100;
			//ajout du discount
			Discounts.partialUpdate(discount.id, discount).then(res => {
				if (res.status == 204) {
					this.updateDiscount()
					// création des différents Discount details
					//récupération de la liste de l'array de discoutDescriptions
					var languages = Object.keys(discountDescriptions);
					for (let i = 0; i < languages.length; i++) {
						if (discountDescriptions[languages[i]].description != "") {
							if (discountDescriptions[languages[i]].id) {
								DiscountDetails.partialUpdate(
									discountDescriptions[languages[i]].id,
									{
										language: discountDescriptions[languages[i]].code,
										description: discountDescriptions[languages[i]]
											.description
									}
								).then();
							} else {
								DiscountDetails.add(discount.id, {
									language: discountDescriptions[languages[i]].code,
									description: discountDescriptions[languages[i]]
										.description
								}).then();
							}
						}
					}
				}
			});
		},
		manageDiscountWithParams(data) {
			if (data.method == "modify_discount")
				this.updateDiscountWithParams(data.discount, data.discountDescriptions);
			if (data.method == "add_discount")
				this.createDiscountWithParams(
					data.discount,
					data.groupOfDiscounts,
					data.discountDescriptions
				);
		}
	}
}